import { toEndISO, toStartISO } from "src/utils/dateRange";
import type { DateRangeValue, FacetFilter } from "../types";

export const buildDateFilters = (
    field: string | undefined,
    range: DateRangeValue | undefined,
): FacetFilter[] => {
    const [start, end] = range ?? [null, null];
    if (!field || !start || !end) return [];
    return [{ key: field, value: [toStartISO(start), toEndISO(end)] }];
};
